export { default } from './PremiumCamCTA';
